import { drivers as barcelonaDrivers, stops as barcelonaStops } from './Barcelona';
import { drivers as buenosAiresDrivers, stops as buenosAiresStops } from './BuenosAires';
import { drivers as CDMXDrivers, stops as CDMXStops } from './CDMX';
import { IExampleDrivers, IExampleLocation } from './interfaces';
import { drivers as limaDrivers, stops as limaStops } from './Lima';
import { drivers as madridDrivers, stops as madridStops } from './Madrid';
import { drivers as santiagoDrivers, stops as santiagoStops } from './Santiago';

export const driverLocations: IExampleDrivers[] = [
  barcelonaDrivers,
  buenosAiresDrivers,
  madridDrivers,
  limaDrivers,
  CDMXDrivers,
  santiagoDrivers,
];

export const stopLocations: IExampleLocation[] = [
  barcelonaStops,
  buenosAiresStops,
  madridStops,
  limaStops,
  CDMXStops,
  santiagoStops,
];
